import debug from 'bows';
import Flickity from 'flickity';

const log = debug('subscribe');

class Subscribe {
	constructor(opts) {
		this.opts = opts;

		this.quotes = Array.from( document.querySelectorAll( '.subscribe__quotes' ) ).map( ( node ) => {
			const wrap = node.querySelector( '.subscribe__quotes-wrap' );

			if ( ! wrap ) {
				return null;
			}

			return new Flickity( wrap, {
				cellAlign: 'left',
				adaptiveHeight: false,
				arrowShape: 'M28,57.67,56.66,87.18a7.68,7.68,0,0,1,0,10.62,7.13,7.13,0,0,1-10.3,0L0,50,46.36,2.22a7.13,7.13,0,0,1,10.3,0,7.68,7.68,0,0,1,0,10.62l0,0L27.75,42.65l65-.15a7.51,7.51,0,0,1,0,15Z',
				on: {
					ready: () => {
						// adjust dot nav
						const nav = document.createElement( 'div' );
						nav.className = 'flickity__nav';
						node.appendChild( nav );

						const pageDots   = node.querySelector( '.flickity-page-dots' );
						const prevButton = node.querySelector( '.flickity-button.previous' );
						const nextButton = node.querySelector( '.flickity-button.next' );

						[ prevButton, pageDots, nextButton ].forEach( ( n ) => {
							if ( n ) {
								nav.appendChild( n );
							}
						});
					}
				}
			} );
		} );

		log(this);
	}
}

export default function( opts = {} ) {
	return new Subscribe(opts);
}
